// import React, { useEffect, useState } from "react";

// import { API_URLS } from "../../../../../../api/apiUrls";
// import { Spin, Card } from "antd"; // optional: Ant Design components
// import { toast } from "react-toastify";
// import { getApi } from "../../../../../../api/api_instance";
// import { useSelector } from "react-redux";

// const LicenseAccess = () => {
//   const [customerData, setCustomerData] = useState(null);
//   const user = useSelector((state) => state.auth.user);
//   const [loading, setLoading] = useState(false);

//   const fetchCustomer = async () => {
//     try {
//       setLoading(true);
//       const response = await getApi({
//         apiUrl: API_URLS.LICENSEACCESS(user._id),
//       });
//       if (response.success) {
//         setCustomerData(response.data);
//       } else {
//         toast.error(response.message || "Failed to fetch data");
//       }
//     } catch (error) {
//       toast.error("Error fetching customer data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCustomer();
//   }, []);

//   if (loading)
//     return (
//       <div className="flex justify-center items-center w-full h-screen">
//         <Spin tip="Loading..." />
//       </div>
//     );

//   if (!customerData) return null;
//   const accessData = {
//     creation_dynamic_form_access: true,
//     creation_dynamic_form_manually_access: true,
//     question_bank_access: true,
//     creation_role_permission_access: true,
//   };

//   const validTillDates = [
//     "31 Dec 2025",
//     "01 Jan 2026",
//     "15 Feb 2026",
//     "10 Mar 2026",
//   ];

//   return (
//     <div
//       style={{ backgroundColor: "#fff" }}
//       className="h-full px-5 pb-5 space-y-4"
//     >
//       <h3 className="text-lg font-semibold text-black">License & Details</h3>
//       <div className="    mb-6 mt-10">
//         {/* Card Header */}

//         {/* Metrics Row */}
//         <div
//           className="grid grid-cols-5  text-sm text-gray-700 bg-white rounded-2xl mt-5 p-4"
//           style={{ boxShadow: "0px 0px 16px 0px #30B7921F" }}
//         >
//           <div>
//             <p className=" text-sm font-semibold text-black ">
//               Customer Set-UP
//             </p>
//             <p className="font-medium text-gray-500">Sub Admin License </p>
//           </div>
//           <div>
//             <p className="   text-sm  font-semibold text-black ">
//               Total Licenses
//             </p>
//             <p className="font-medium text-gray-500">
//               {customerData.license.sub_admin.total}
//             </p>
//           </div>
//           <div>
//             <p className=" text-sm  font-semibold text-black">Used</p>
//             <p className="font-medium text-gray-500">
//               {customerData.license.sub_admin.used}
//             </p>
//           </div>
//           <div>
//             <p className=" text-sm  font-semibold text-black">Remaining</p>
//             <p className="font-medium text-gray-500">
//               {customerData.license.sub_admin.unused}
//             </p>
//           </div>
//           <div>
//             <p className=" text-sm  font-semibold text-black">Valid Till</p>
//             <p className="font-medium text-gray-500">22/03/2025</p>
//           </div>
//         </div>

//         <div
//           className="grid grid-cols-3 gap-4 text-sm text-gray-700 bg-white rounded-2xl mt-5 p-4 shadow-md"
//           style={{ boxShadow: "0px 0px 16px 0px #30B7921F" }}
//         >
//           {/* Customer Set-up */}
//           <div>
//             <p className="text-sm  font-semibold text-black">Customer Set-up</p>

//             {Object.entries(accessData).map(([key, value]) => (
//               <div key={key} className="flex justify-between text-xs mb-1">
//                 <span className="capitalize">{key.replace(/_/g, " ")}</span>
//               </div>
//             ))}
//           </div>

//           <div>
//             <p className="text-sm  font-semibold text-black">Access</p>

//             {Object.entries(accessData).map(([key, value]) => (
//               <div key={key} className="flex justify-between text-xs mb-1">
//                 <span className="font-medium">{value ? "Yes" : "No"}</span>
//               </div>
//             ))}
//           </div>

//           {/* ACCESS */}

//           {/* VALID TILL */}
//           <div>
//             <p className="text-sm  font-semibold text-black">VALID TILL</p>
//             {validTillDates.map((date, idx) => (
//               <p key={idx} className="text-sm text-black font-medium mb-1">
//                 {date}
//               </p>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LicenseAccess;

import React, { useEffect, useState } from "react";
// import { API_URLS } from "../../../../../../api/apiUrls";
import { Spin } from "antd";
import { toast } from "react-toastify";
// import { getApi } from "../../../../../../api/api_instance";
import { useSelector } from "react-redux";
import { API_URLS } from "../../../../../api/apiUrls";
import { getApi } from "../../../../../api/api_instance";

const LicenseAcces = () => {
  const [customerData, setCustomerData] = useState(null);
  const user = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(false);

  const fetchCustomer = async () => {
    try {
      setLoading(true);
      const response = await getApi({
        apiUrl: API_URLS.LICENSEACCESS(user._id),
      });
      if (response.success) {
        setCustomerData(response.data);
      } else {
        toast.error(response.message || "Failed to fetch data");
      }
    } catch (error) {
      toast.error("Error fetching customer data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomer();
  }, []);

  if (loading)
    return (
      <div className="flex justify-center items-center w-full h-screen">
        <Spin tip="Loading..." />
      </div>
    );

  if (!customerData) return null;

  const accessData = {
    creation_dynamic_form_access: true,
    creation_dynamic_form_manually_access: true,
    question_bank_access: true,
    creation_role_permission_access: true,
  };

  const validTillDates = [
    "31 Dec 2025",
    "01 Jan 2026",
    "15 Feb 2026",
    "10 Mar 2026",
  ];

  return (
    <div className="w-full bg-white h-full px-4 sm:px-6 lg:px-12 py-5 space-y-6">
      <h3 className="text-lg font-semibold text-black">License & Details</h3>

      {/* Sub Admin License Summary Grid */}
      <div
        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 text-sm text-gray-700 bg-white rounded-2xl p-4"
        style={{ boxShadow: "0px 0px 16px 0px #30B7921F" }}
      >
        <div>
          <p className="text-sm font-semibold text-black">Customer Set-UP</p>
          <p className="font-medium text-gray-500">Sub Admin License</p>
        </div>
        <div>
          <p className="text-sm font-semibold text-black">Total Licenses</p>
          <p className="font-medium text-gray-500">
            {customerData.license.sub_admin.total}
          </p>
        </div>
        <div>
          <p className="text-sm font-semibold text-black">Used</p>
          <p className="font-medium text-gray-500">
            {customerData.license.sub_admin.used}
          </p>
        </div>
        <div>
          <p className="text-sm font-semibold text-black">Remaining</p>
          <p className="font-medium text-gray-500">
            {customerData.license.sub_admin.unused}
          </p>
        </div>
        <div>
          <p className="text-sm font-semibold text-black">Valid Till</p>
          <p className="font-medium text-gray-500">22/03/2025</p>
        </div>
      </div>

      {/* Access Detail Grid */}
      <div
        className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-white rounded-2xl p-4"
        style={{ boxShadow: "0px 0px 16px 0px #30B7921F" }}
      >
        {/* Access Labels */}
        <div>
          <p className="text-sm font-semibold text-black mb-2">
            Customer Set-up
          </p>
          {Object.entries(accessData).map(([key]) => (
            <div key={key} className="text-xs text-gray-600 mb-1 capitalize">
              {key.replace(/_/g, " ")}
            </div>
          ))}
        </div>

        {/* Access Values */}
        <div>
          <p className="text-sm font-semibold text-black mb-2">Access</p>
          {Object.entries(accessData).map(([key, value]) => (
            <div key={key} className="text-xs font-medium mb-1">
              {value ? "Yes" : "No"}
            </div>
          ))}
        </div>

        {/* Valid Till Dates */}
        <div>
          <p className="text-sm font-semibold text-black mb-2">Valid Till</p>
          {validTillDates.map((date, idx) => (
            <p key={idx} className="text-xs font-medium text-black mb-1">
              {date}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LicenseAcces;
